// extracted by mini-css-extract-plugin
module.exports = {"points_container":"ScoreBoard_points_container__2thsM","points":"ScoreBoard_points__2hqSY"};